
import Vue from "vue";
import { Component } from "vue-property-decorator";
import SingularityPanelHeader from "../../PanelHeader/SingularityPanelHeader.vue";
import BrandTypographyPicker from "./BrandTypographyPicker.vue";
import { singularityStore, configStore } from "@/store/store";
import { Font } from "@/types/fonts";
import BrandTypographyCategory from "./BrandTypographyCategory.vue";
import { updateGlobalTypography } from "@/lib/singularity/brand/typography";

@Component({
  components: {
    SingularityPanelHeader,
    BrandTypographyPicker,
    BrandTypographyCategory
  }
})
export default class BrandPanelTypographyEdit extends Vue {
  get currentFont() {
    return singularityStore.currentFont;
  }

  currentCategory = "";

  get fontsByCategory() {
    return configStore.fonts.reduce((acc: any, font: Font) => {
      const category = font.category || "Other";
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(font);
      return acc;
    }, {});
  }

  get filteredFontsByCategory() {
    if (!this.currentCategory) {
      return this.fontsByCategory;
    }
    return {
      [this.currentCategory]: this.fontsByCategory[this.currentCategory] || []
    };
  }

  showCategory(category: string) {
    this.currentCategory = category;
  }

  update(font: Font) {
    if (!this.currentFont) return;
    singularityStore.setSingularityLeftPanel("brand");
    updateGlobalTypography(this.currentFont, font.slug);
  }
}
